// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 962) return "home.77fca1.js";
	if (chunkId === 144) return "archive-video-tips.6f4490.js";
	if (chunkId === 386) return "archive-recipe.19ef32.js";
	if (chunkId === 609) return "faq.a86317.js";
	if (chunkId === 371) return "poll-cookie.ddcba9.js";
	if (chunkId === 510) return "ok-videos.ab2278.js";
	if (chunkId === 584) return "single-flavor.7d1289.js";
	if (chunkId === 238) return "single-recipe.cf61dd.js";
	if (chunkId === 46) return "product-landing.6c52b9.js";
	// return url for filenames based on template
	return undefined;
};